export enum MemberStatus {
    Active = 1,
    Suspended = 3,
    Terminated = 4,
    Pending = 6,
    Restricted = 7
}

export enum MemberStatusName{
    Active = "Active",
    Suspended = "Suspended",
    Terminated = "Terminated",
    Pending = "Pending",
    Restricted = "Restricted"
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/member-status.enum.ts